import { Constants, HttpClient } from '@pwc/pwc-deals-web-common';
import { useParams } from 'react-router-dom';

import AutoCreate, { ContentType } from 'common/components/AutoCreate';

import { isCreateFreeFormAnalysisApiEnabled } from 'common/helpers/featureFlags';
import styles from 'common/components/AutoCreate/AutoCreate.module.scss';
import { CreateFFAHttpClient } from 'common/services/httpClient';

import { mapDto as mapDtoOriginal } from '../FreeformAnalysisForm/FreeformAnalysisFormUtil/FreeformAnalysisFormUtil';
import { postAnalysis } from '../../analysesService';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
const mapDto = mapDtoOriginal as (x: any) => any;

const maxId = 10 ** 6;

const CreateFreeformAnalysis: React.FunctionComponent = () => {
  const { projectId } = useParams<{
    readonly projectId: string;
  }>();

  const initialSections = [
    {
      order: 1,
      layoutType: Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
      items: [],
    },
  ];

  return (
    <AutoCreate
      contentType={ContentType.FreeFormAnalysis}
      createApiEndpointUrl={`/projects/${projectId}/analysis`}
      makeEditUrl={(analysisId) =>
        `/projects/${projectId}/analyses/${analysisId}/edit`
      }
      httpClient={
        isCreateFreeFormAnalysisApiEnabled
          ? // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
            CreateFFAHttpClient(projectId)
          : ({
              post: async () => ({
                data: {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                  contentId: await postAnalysis(
                    projectId,
                    mapDto({
                      body: '',
                      insight: '',
                      sections: initialSections,
                      title: `Untitled Analysis ${Math.floor(
                        Math.random() * maxId
                      )}`,
                    })
                  ),
                },
              }),
            } as unknown as HttpClient)
      }
      errorClasses={styles['error-wrapper']}
      loaderClasses={styles['loader-wrapper']}
    />
  );
};

export default CreateFreeformAnalysis;
